import Celebration from './Celebration';

class Birthday extends Celebration {}

export default Birthday;
